import FooterLink from "./components/FooterLink";
import GenericText from "./components/GenericText";
import LargeHeader from "./components/LargeHeader";
import MediumHeader from "./components/MediumHeader";
import Navbar from "./components/Navbar";
import Page from "./components/Page";
import SlideIn from "./components/SlideIn";
import SmallHeader from "./components/SmallHeader";
import bg from "./images/tmgbg.png";
import { copy } from "./text";

function App() {
  return (
    <div className="bg-primary">
      <Navbar />
      <Page id="home" className="flex flex-col">
        <div className="flex items-center justify-center w-full flex-grow">
          <div className="max-w-lg w-full text-center">
            <SmallHeader className="mb-2">{copy.companyName}</SmallHeader>
            <LargeHeader className="mb-8">{copy.homeTitle}</LargeHeader>
            <div className="text-lg mb-12 text-secondary">{copy.homeText}</div>
          </div>
        </div>
        <FooterLink to="#testimonials" label={copy.ourWorkHeader} />
      </Page>
      <Page id="testimonials" className="flex flex-col">
        <div className="flex items-center justify-center flex-grow">
          <div className="max-w-7xl mb-16 md:mb-0">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-16 ">
              <SlideIn className="">
                <div
                  className="h-64 rounded-xl shadow-xl flex items-center justify-center mb-4"
                  style={{
                    background:
                      "linear-gradient(rgb(54, 54, 54) 0%, rgb(13, 13, 13) 100%)",
                  }}
                >
                  <img src="/phar.avif" className="w-32" />
                </div>
                <SmallHeader className="mb-2">
                  {copy.ourWorkCompany1Name}
                </SmallHeader>
                <GenericText>{copy.ourWorkCompany1Description}</GenericText>
              </SlideIn>
              <SlideIn className="md:mt-16">
                <div
                  className="mb-4 h-64 rounded-xl shadow-xl flex items-center justify-center"
                  style={{
                    background:
                      "linear-gradient(90deg, rgba(45,55,72,1) 0%, rgba(92,107,134,1) 100%)",
                  }}
                >
                  <div className="flex flex-col items-center justify-center">
                    <img src="/quali.png" className="w-24" />
                    <div className="text-white text-xl">Quali-Service</div>
                  </div>
                </div>
                <SmallHeader className="mb-2">
                  {copy.ourWorkCompany2Name}
                </SmallHeader>
                <GenericText>{copy.ourWorkCompany2Description}</GenericText>
              </SlideIn>
              <SlideIn className="md:mt-32">
                <div
                  className="mb-4 h-64 rounded-xl shadow-xl overflow-hidden flex items-center justify-center"
                  style={{ backgroundImage: `url(${bg})` }}
                >
                  <img src="/tmg.png" className="w-24" />
                </div>
                <SmallHeader className="mb-2">
                  {copy.ourWorkCompany3Name}
                </SmallHeader>
                <GenericText>{copy.ourWorkCompany3Description}</GenericText>
              </SlideIn>
            </div>
          </div>
        </div>
        <FooterLink to="#contact" label={copy.contactHeader} />
      </Page>
      <Page id="contact" className="flex items-center justify-center">
        <div className="max-w-xl w-full text-center">
          <SlideIn className="mb-32">
            <MediumHeader className="mb-4">{copy.contactHeader}</MediumHeader>
            <GenericText className="mb-8">
              {copy.contactUs}&nbsp;{copy.contactEmail}.
            </GenericText>
            <a
              href={`mailto:${copy.contactEmail}`}
              className="inline-block bg-secondary text-white px-12 py-4 rounded hover:-translate-y-1 transition-all"
            >
              {copy.contactButton}
            </a>
          </SlideIn>
        </div>
      </Page>
    </div>
  );
}

export default App;
